<template>

<div>
  <b-alert
    :show="showAlert"
    @dismissed='showAlert = false'
    dismissible
    fade
    variant="success"
  >
    Comando enviado com sucesso!
  </b-alert>

  <div class="row">
    <div class="form-group col-lg-6">
      <label for="serial">{{ $t('serial') }}</label>
      <input
        type="text"
        id="serial"
        name="serial"
        class="form-control"
        :placeholder="$t('ph_serial')"
        v-model="serial"
      >
    </div>

    <div class="form-group col-lg-6">
      <label for="board">{{ $t('board') }}</label>
      <input
        type="text"
        id="board"
        name="board"
        class="form-control"
        :placeholder="$t('ph_board')"
        :value="board"
        @input="event => board = event.target.value.toUpperCase()"
        v-validate="'max:8|regex:[A-Z]{3}-{1}[0-9]{1}[0-9A-Z]{1}[0-9]{2}'"
        maxlength="8"
      >
    </div>
  </div>

  <LoaderButton
    id="search"
    @click="getLastPosition"
  >
    {{ $t('search') }}
  </LoaderButton>

  <div class="row">
    <div class="col-12">
      <b-table
        responsive='xl'
        bordered
        hover
        class="bg-white"
        :items="lastPosition"
        :fields='fieldsLastPositions'
      >
        <template v-slot:cell(newOffsetTemp)>
          <input
            type="number"
            step="0.01"
            id="newOffsetTemp"
            name="newOffsetTemp"
            class="form-control text-right"
            :placeholder="$t('ph_newOffset')"
            v-model="newOffsetTemp"
          >
        </template>

        <template v-slot:cell(vehicleId)=value>
          <div class="text-center">
            <b-button
              variant='primary'
              @click="() => setOffset(value.item.vehicleId)"
              size="sm"
              :disabled="value.item.offsetTemp == newOffsetTemp"
            >
              Alterar Offset
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</div>

</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import moment from 'moment-timezone'
import { request } from '@/lib/http'

export default {
  name: 'OffsetTemp',
  components: {
    LoaderButton
  },

  data () {
    return {
      serial: '',
      board: '',
      fieldsLastPositions: [
        {
          key: 'timestamp',
          label: this.$t('server_hour'),
          formatter: (value, key, item) => {
            return value
              ? moment(value).tz('America/Recife').add(3, 'hours').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 'datetime',
          label: this.$t('gps_hour'),
          formatter: (value, key, item) => {
            return value
              ? moment(value).tz('America/Recife').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 'data_hora_temperatura',
          label: 'Data S1',
          formatter: (value, key, item) => {
            return value
              ? moment(value).tz('America/Recife').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 's1',
          label: 'Temp S1'
        },
        {
          key: 'offsetTemp',
          label: this.$t('Offset')
        },
        {
          key: 'newOffsetTemp',
          label: 'Novo Offset'
        },
        {
          key: 'vehicleId',
          label: ''
        }
      ],
      lastPosition: [],
      newOffsetTemp: undefined,
      vehicleId: undefined,
      showAlert: false
    }
  },

  watch: {
    board: function(value) {
      // Define máscara da placa
      if (window.event.inputType === 'deleteContentBackward') {
        return
      }

      if (value.length === 3){
        this.board = value + '-'
      }

      if (value.length === 4 && !value.includes('-')) {
        this.board = value.substr(0,3)+"-"+value.substr(3)
      }
    },

    lastPosition: function(value) {
      this.newOffsetTemp = value.length > 0
        ? value[0].newOffsetTemp
        : undefined
    }
  },

  methods: {
    async getLastPosition() {
      const { dispatch } = this.$store

      if (!this.serial && !this.board) {
        return dispatch('notify/error', { message: 'É necessário informar o serial ou placa do veículo' })
      }

      dispatch('overlay/show', true)

      let params = {}
      if (this.serial) {
        params.serial = this.serial
      }
      if (this.board) {
        params.board = this.board
      }

      const { rows } = await request({
        url   : 'vehicledata',
        method: 'get',
        params
      })

      if (rows.length === 0) {
        this.lastPosition = []

        dispatch('overlay/show', false)

        return dispatch('notify/error', { message: 'Veículo não encontrado!' })
      }

      try {
        const position = await request({
          url   : 'position-and-offset',
          method: 'get',
          params: { vehicleId: rows[0].VEI_ID }
        })

        if (position.length > 0) {
          const last = []
          last.push(position[0])

          this.lastPosition = last
        } else {
          this.lastPosition = []
        }
      } catch (error) {}

      dispatch('overlay/show', false)
    },

    async setOffset(vehicleId) {
      const { dispatch } = this.$store

      dispatch('overlay/show', true)

      try {
        await request({
          url   : `arena-offset-temperature/${vehicleId}`,
          method: 'patch',
          data: {
            newOffset: this.newOffsetTemp
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        dispatch('overlay/show', false)
        $('#search').trigger('click')
      }

    },
  },
}
</script>
